export default __webpack_public_path__ + "static/media/reqsent.a8b76196.gif";